import StorageProvider from './storageProvider';

export default class TenantSessionService {
  static storage = new StorageProvider(
    window.localStorage,
    (storageProvider, key, value) => {
      storageProvider.setItem(key, JSON.stringify(value));
    },
    (storageProvider, key) => {
      const value = storageProvider.getItem(key);
      return value ? JSON.parse(value) : null;
    },
    (storageProvider, key) => {
      storageProvider.removeItem(key);
    },
    process.env.NODE_ENV === 'development' ? '_tenant' : '_t',
    {
      lastTenant: process.env.NODE_ENV === 'development' ? 'lastTenant' : 'lt'
    }
  );

  static saveLastTenant(lastTenant) {
    this.storage.saveElement('lastTenant', lastTenant);
  }

  static getLastTenant() {
    return this.storage.getElement('lastTenant');
  }

  static removeLastTenant() {
    return this.storage.removeElement('lastTenant');
  }
}
